import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { action } from 'mobx';
import { IAppOnlyStore } from 'stores/AllStores';
import { UserEditableProperties } from 'stores/User';
import { scrollWindow } from 'events/scroll';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';

// Styles
const s = require('./UserProfile.css');

// Component
@inject('store')
@observer
export class ChangePasswordForm extends React.Component<IAppOnlyStore, {}> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        const { user } = this.props.store;

        return (
            <div className={s.editing} >
                <div className={s.group}>
                    <label>
                        <p>
                            <span>Current password</span>
                        </p>
                        <input
                            type="password"
                            value={user.changeUserPassword.currentPassword}
                            onChange={this.handleUserChange(UserEditableProperties.currentPassword)}
                        />
                    </label>

                    <label>
                        <p>
                            <span>New password</span>
                        </p>
                        <input
                            type="password"
                            value={user.changeUserPassword.newPassword}
                            onChange={this.handleUserChange(UserEditableProperties.newPassword)}
                        />
                    </label>

                    <label>
                        <p>
                            <span>Confirm new password</span>
                        </p>
                        <input
                            type="password"
                            value={user.changeUserPassword.confirmPassword}
                            onChange={this.handleUserChange(UserEditableProperties.confirmPassword)}
                        />
                    </label>
                </div>

                <div className={s.details}>
                    <div>
                        <button className="boxButton" onClick={this.handleSaveChanges}>Save changes</button>
                    </div>
                    <div>
                        <SavingIndicator
                            labels={{
                                saving: 'Saving changes...',
                                error: 'All fields are required and current password needs to match your existing password, try again',
                                success: 'Password has been changed',
                            }}
                            status={
                                user.userChangePasswordSavingError
                                    ? SavingIndicatorStatus.Error
                                    : user.userChangePasswordSavingSuccess
                                        ? SavingIndicatorStatus.Success
                                        : user.userChangePasswordSaving
                                            ? SavingIndicatorStatus.Saving
                                            : SavingIndicatorStatus.None
                            }
                        />
                    </div>
                </div>
            </div>
        );
    }

    @action private handleUserChange = (property: UserEditableProperties) => (e: React.FormEvent<HTMLInputElement>) => {
        this.props.store.user.changeUserPassword[property] = e.currentTarget.value;
        this.props.store.user.changeUserPassword.modified = true;
    };

    private handleSaveChanges = () => {
        this.props.store.user.updateUserPassword().then((success) => {
            scrollWindow.toY(0);
        });
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Profile/ChangePasswordForm.tsx